import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import RuleIcon from '@mui/icons-material/Rule';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import { useNavigate } from 'react-router-dom';

const listItemStyle = {
  display: 'flex',
  alignItems: 'center',
  // bgcolor:'#f1f8e9',
};

const avatarStyle = {
  display: 'flex',
  width: '40px',
  height: '40px',
  bgcolor: '#c8e6c9',
};

const primaryTextStyle = {
  display: 'flex',
  fontSize:'12px',
  // fontWeight: 'bold'
}

const secondaryTextStyle = {
  display: 'flex',
  fontWeight: 'bolder',
  fontSize: '20px',
};

export default function InsetDividers() {
  const navigate = useNavigate()
  return (
    <List
      sx={{
        padding:'1px',
        bgcolor:'#f1f8e9',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        borderRadius: '20px'
      }}
    >
      <ListItem sx={listItemStyle}>
        <ListItemAvatar>
          <Avatar sx={avatarStyle}>
            <AssignmentIcon sx={{color:'#66bb6a'}} onClick={() => navigate('/estimate')} />
          </Avatar>
        </ListItemAvatar>
        <div>
          <div style={primaryTextStyle}>Today Expected Jobs</div>
          <div style={secondaryTextStyle}>15</div>
        </div>
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem sx={listItemStyle} >
        <ListItemAvatar>
          <Avatar sx={avatarStyle}>
            <AssignmentLateIcon sx={{color:'#66bb6a'}} onClick={() => navigate('/service_Order')} />
          </Avatar>
        </ListItemAvatar>
        <div>
          <div style={primaryTextStyle}>Pending Jobs to Complete</div>
          <div style={secondaryTextStyle}>7</div>
        </div>
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem sx={listItemStyle}>
        <ListItemAvatar>
          <Avatar sx={avatarStyle}>
            <RuleIcon sx={{color:'#66bb6a'}} onClick={() => navigate('/estimate')} />
          </Avatar>
        </ListItemAvatar>
        <div>
          <div style={primaryTextStyle}>Pending Estimate to Approve</div>
          <div style={secondaryTextStyle}>12</div>
        </div>
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem sx={listItemStyle}>
        <ListItemAvatar>
          <Avatar sx={avatarStyle}>
            <SaveAsIcon sx={{color:'#66bb6a'}} onClick={() => navigate('/enquiry')}  />
          </Avatar>
        </ListItemAvatar>
        <div>
          <div style={primaryTextStyle}>Pending Enquiry for Estimate</div>
          <div style={secondaryTextStyle}>8</div>
        </div>
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem sx={listItemStyle}>
        <ListItemAvatar>
          <Avatar sx={avatarStyle}>
            <CheckBoxIcon sx={{color:'#66bb6a'}} onClick={() => navigate('/Cash_Job')} />
          </Avatar>
        </ListItemAvatar>
        <div>
          <div style={primaryTextStyle}>Total Cash Job Done</div>
          <div style={secondaryTextStyle}>25</div>
        </div>
      </ListItem>
    </List>
  );
}
